export default __webpack_public_path__ + "static/media/logo.ebe9b603.png";